/**
 * Created by Sergii Kravtsov 12.06.22
 */

const getTranslateFunc = function () {
  let i18n;

  try {
    i18n = require('@/lang/i18n.js').default;
  } catch (error) {
    // console.log(error);
  }

  return i18n
    ? (translateAlias) => i18n.t(translateAlias)
    : (translateAlias) => translateAlias;
};

const getTranslate = getTranslateFunc();

//Должен называться так же как и в modules_components_obj
let module_name = 'FastLine';

let module_settings = {
  module_name,
};

//Корневой урл модуля
let module_alias = 'fast_line';

//Список разрешений модуля
module_settings.permits = {
  front: {
    //Отображение пунктов меню
    fast_line_show_menu_item: {
      description: 'Отображать в меню пункт Fast Line',
    },
    fast_line_show_tab_item: {
      description: 'Отображать таб Fast Line',
    },
  },

  back: {}
};

//Пункты в меню
module_settings.menu_items = [
  {
    title: getTranslate('modules.fast_line.module_settings.fast_line'),
    module: module_name,
    alias: module_alias,
    icon: 'mdi-robot-happy-outline',
    permits: { show: 'fast_line_show_menu_item' },
    show: true,
    route: 'fastline',
  },
];

//Табы модуля
module_settings.tabs_items = {};

module_settings.tabs_items[module_name] = {
  use_tabs: true,
  tabs_items: [
    {
      tab: getTranslate('modules.fast_line.module_settings.fast_line'),
      content: '',
      show: true,
      type: 'fastline',
      permits: { show: 'fast_line_show_tab_item' },
      route: 'section',
    },
  ],
};

//Подключенные компоненты
module_settings.components = [
  {
    name: module_name,
    path: 'Component/tabs/FastLine.vue',
  },
];

//Экспорт для vue и для node
module.exports = { module_settings };
module.exports.default = { module_settings };
